import { Outlet } from 'react-router-dom';

import { FlexCol } from '~/modules/artist-roster/components/flex/FlexCol';
import { TabLinks } from '~/modules/marketing/pages/catalog-anomaly-dashboard/components/TabLinks';

export function CatalogAnomalyDashboardPage() {
  return (
    <FlexCol className="h-[calc(100vh-80px)]">
      <TabLinks className="px-xl pt-xl" />
      <div className="flex-grow">
        <Outlet />
      </div>
    </FlexCol>
  );
}

CatalogAnomalyDashboardPage.displayName = 'CatalogAnomalyDashboardPage';
